import store from '@/store'
import Vue from 'vue'
import { setError } from '@/plugins/axios/errorParser'

window.onerror = (msg, src, linenum, colnum, error) => {
  console.error(msg, src, linenum, colnum, error)
}

Vue.config.errorHandler = async (err, vm, info) => {
  // 400 에러는 공통적으로 처리한다.
  const { status } = err
  if (status === 400) {
    console.log('400에러', err)
    //const data = setError(err)
    // let message = ''
    // for (const k in data) {
    //   setError({
    //     data
    //   })
    //   message += `${data[k]}<br/>`
    // }
    await $swal.basic.error({ html: err.message })
    throw err
  }
  if (err.name === 'NavigationDuplicated') {
    return store.dispatch('time/refresh')
  } else if (err.message && err.message.indexOf('via a navigation guard.') > -1) {
    return
  } else {
    console.error('에러!', err, err.status)
    store.dispatch('errors/add', { title: '정의되지 않은 에러 발생', message: err })
  }
  throw err
}
